(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-search-results-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async function () {
    for (const filterSidebarComponent of [...document.querySelectorAll('[data-filter-sidebar="collection-filter"]')]) {
      FilterSidebarFactory(filterSidebarComponent);
    }
    for (const collectionGridComponent of [...document.querySelectorAll('[data-collection-grid]')]) {
      CollectionGridFactory(collectionGridComponent);
    }
    for (const collectionPageComponent of [...document.querySelectorAll('.collection__content')]) {
      CollectionPageFactory(collectionPageComponent);
    }
  });
  document.addEventListener('facet:updated', async (event) => {
    for (const filterSidebarComponent of [...document.querySelectorAll('[data-filter-sidebar="collection-filter"]')]) {
      FilterSidebarFactory(filterSidebarComponent);
    }
    for (const collectionGridComponent of [...document.querySelectorAll('[data-collection-grid]')]) {
      CollectionGridFactory(collectionGridComponent);
    }
    // setTimeout(() => {}, 1500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-guide-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async function () {
    for (const filterSidebarComponent of [...document.querySelectorAll('[data-filter-sidebar="collection-filter"]')]) {
      FilterSidebarFactory(filterSidebarComponent);
    }
  });
  document.addEventListener('facet:update', async (event) => {
    setTimeout(() => {
      for (const filterSidebarComponent of [
        ...document.querySelectorAll('[data-filter-sidebar="collection-filter"]'),
      ]) {
        FilterSidebarFactory(filterSidebarComponent);
      }
    }, 1500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async function () {
    for (const filterSidebarComponent of [...document.querySelectorAll('[data-filter-sidebar="collection-filter"]')]) {
      FilterSidebarFactory(filterSidebarComponent);
    }
    for (const collectionGridComponent of [...document.querySelectorAll('[data-collection-grid]')]) {
      CollectionGridFactory(collectionGridComponent);
    }
    for (const collectionPageComponent of [...document.querySelectorAll('.collection__content')]) {
      CollectionPageFactory(collectionPageComponent);
    }
  });
  document.addEventListener('facet:updated', async (event) => {
    for (const filterSidebarComponent of [...document.querySelectorAll('[data-filter-sidebar="collection-filter"]')]) {
      FilterSidebarFactory(filterSidebarComponent);
    }
    for (const collectionGridComponent of [...document.querySelectorAll('[data-collection-grid]')]) {
      CollectionGridFactory(collectionGridComponent);
    }
    setTimeout(() => {}, 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async function () {
    for (const filterSidebarComponent of [...document.querySelectorAll('[data-filter-sidebar="collection-filter"]')]) {
      FilterSidebarFactory(filterSidebarComponent);
    }
    for (const collectionGridComponent of [...document.querySelectorAll('[data-collection-grid]')]) {
      CollectionGridFactory(collectionGridComponent);
    }
    for (const collectionPageComponent of [...document.querySelectorAll('.collection__content')]) {
      CollectionPageFactory(collectionPageComponent);
    }
  });
  document.addEventListener('facet:updated', async (event) => {
    for (const filterSidebarComponent of [...document.querySelectorAll('[data-filter-sidebar="collection-filter"]')]) {
      FilterSidebarFactory(filterSidebarComponent);
    }
    for (const collectionGridComponent of [...document.querySelectorAll('[data-collection-grid]')]) {
      CollectionGridFactory(collectionGridComponent);
    }
    // setTimeout(() => {}, 1500);
  });

  } catch(e) { console.error(e); }
})();
})();
